Vue.component('of-donation-status', {
  _scopeId: 'data-v-26e067ba',
  owCSS: `.mob-hidden[data-v-26e067ba]{display:block}.web-hidden[data-v-26e067ba]{display:none}.amount-container[data-v-26e067ba]{padding:64px 92px;background:#fafafa;border-radius:12px;box-shadow:0 2px 9px 0 rgba(0,0,0,.08)}.amount-container .get-amount[data-v-26e067ba]{color:rgba(0,0,0,.86);font-size:32px;font-weight:500;line-height:48px}.amount-container .sub-heading[data-v-26e067ba]{color:rgba(0,0,0,.56);font-size:20px;font-weight:500;line-height:28px}.amount-container .slider-move[data-v-26e067ba]{background:#318739;height:16px;position:absolute;border-radius:4px}.amount-container .slider-move .active[data-v-26e067ba]{width:100%}.amount-container .progress-container[data-v-26e067ba]{background:#fff;position:relative;width:100%;margin-bottom:50px}.amount-container .progress-container ul li[data-v-26e067ba]{height:16px;width:24%;display:inline-block;float:left;padding:0!important;width:100%;border-radius:3px;background:#eff1f3}.amount-container .progress-container ul[data-v-26e067ba]{list-style:none;padding:0;margin-top:16px}.amount-container h2[data-v-26e067ba]{color:rgba(0,0,0,.86);font-size:20px;font-weight:500;letter-spacing:0;line-height:28px;clear:both}.amount-container p[data-v-26e067ba]{color:rgba(0,0,0,.36);font-size:16px;font-weight:400;line-height:24px;margin-bottom:24px;padding:4px 0}.amount-container .tnc[data-v-26e067ba]{font-size:12px;line-height:16px;margin-top:14px;margin-bottom:0}.amount-container a[data-v-26e067ba]{color:#979797}.amount-container .cards li[data-v-26e067ba]{display:inline-block;width:176px;height:80px;background:#fff;box-shadow:0 0 2px 0 rgba(0,0,0,.06),0 1px 3px 0 rgba(0,0,0,.24);border-radius:6px;margin-right:10px;margin-bottom:10px}.amount-container .cards li[data-v-26e067ba]:last-child{margin-right:0}.amount-container .cards li a[data-v-26e067ba]{color:rgba(0,0,0,.86);font-size:20px;font-weight:400;letter-spacing:0;line-height:24px;text-decoration:none}.amount-container .cards li .desc[data-v-26e067ba]{color:rgba(0,0,0,.86);font-size:20px;font-weight:400;letter-spacing:0;line-height:24px;float:left;padding:16px;width:60%;margin-top:11px}.amount-container .cards li:last-child .desc[data-v-26e067ba]{margin-top:0}.amount-container .cards li .desc div[data-v-26e067ba]{color:rgba(0,0,0,.36);font-size:14px;font-weight:400;line-height:20px;margin-top:4px}.amount-container .cards li img[data-v-26e067ba]{width:9px;vertical-align:middle;float:right;margin-top:32px;margin-right:18px}@media only screen and (max-width:768px){.amount-container .slider-move[data-v-26e067ba]{height:12px!important}.amount-container p[data-v-26e067ba]{margin-bottom:0;font-size:12px}.amount-container .progress-container ul li[data-v-26e067ba]{height:12px!important}.mob-hidden[data-v-26e067ba]{display:none}.web-hidden[data-v-26e067ba]{display:block}}@media only screen and (min-width:320px) and (max-width:600px){.amount-container[data-v-26e067ba]{padding:20px;margin-top:-200px}.amount-container .get-amount[data-v-26e067ba]{font-size:24px;line-height:32px}.amount-container .sub-heading[data-v-26e067ba]{font-size:14px;line-height:20px;display:block}.amount-container h2[data-v-26e067ba]{font-size:16px;line-height:28px}.amount-container .cards li[data-v-26e067ba]{width:49%;height:64px;margin-right:0!important;margin-bottom:8px}.amount-container .cards li[data-v-26e067ba]:nth-child(2n){float:right}.amount-container .cards li[data-v-26e067ba]:last-child{width:100%;height:48px}.amount-container .cards li:last-child .desc[data-v-26e067ba]{padding:12px}.amount-container .cards li:last-child img[data-v-26e067ba]{margin-top:17px!important}.amount-container .cards li a[data-v-26e067ba]{font-size:16px!important;line-height:32px!important}.amount-container .cards li span[data-v-26e067ba]{font-size:14px!important;line-height:28px!important}.amount-container .cards li .desc[data-v-26e067ba]{font-size:16px;line-height:24px;padding:10px}.amount-container .cards li .desc div[data-v-26e067ba]{font-size:12px;line-height:20px;margin-top:1px}.amount-container p[data-v-26e067ba]{font-size:12px!important;line-height:16px!important;margin-bottom:24px!important}.amount-container .cards li img[data-v-26e067ba]{margin-top:24px!important;margin-right:10px!important}}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', [_c('div', {
      staticClass: "amount-container"
    }, [_c('h2', [_vm._v("Make a contribution")]), _vm._v(" "), _c('p', [_vm._v("UPI, debit/credit cards and net banking available")]), _vm._v(" "), _c('ul', {
      staticClass: "cards mob-hidden"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_500,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('500_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹500")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_1000,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('1000_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹1000")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_1500,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('1500_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹1500")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_2000,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('2000_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹2000")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_others,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('amount_of_choice_clicked')
        }
      }
    }, [_vm._m(0), _vm._v(" "), _c('div', {
      staticClass: "desc web-hidden"
    }, [_vm._v("Amount of your choice")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])])]), _vm._v(" "), _c('ul', {
      staticClass: "cards web-hidden"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_500
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('500_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹500")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_1000
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('1000_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹1000")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_1500
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('1500_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹1500")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_2000
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('2000_clicked')
        }
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_vm._v("₹2000")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": _vm.payuUrl.P_others
      },
      on: {
        "click": function($event) {
          return _vm.trackEvent('amount_of_choice_clicked')
        }
      }
    }, [_vm._m(1), _vm._v(" "), _c('div', {
      staticClass: "desc web-hidden"
    }, [_vm._v("Amount of your choice")]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "arrow",
        "src": "../images/donate/arrow-dark.svg",
        "title": ">"
      }
    })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
  },
  staticRenderFns: [function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "desc mob-hidden"
    }, [_vm._v("Amount of "), _c('br'), _vm._v(" your choice")])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "desc mob-hidden"
    }, [_vm._v("Amount of "), _c('br'), _vm._v(" your choice")])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('p', {
      staticClass: "tnc mob-hidden"
    }, [_vm._v("By proceeding, you agree to accept our "), _c('a', {
      attrs: {
        "href": "../images/donate/donate.pdf",
        "target": "_blanck"
      }
    }, [_vm._v("T&Cs.")])])
  }, function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('p', {
      staticClass: "tnc web-hidden"
    }, [_vm._v("By proceeding, you agree to accept our "), _c('a', {
      attrs: {
        "href": "../images/donate/donate.pdf"
      }
    }, [_vm._v("T&Cs.")])])
  }],

  name: "of-donation-status",
  data: function data() {
    return {
      sec1: "",
      sec2: "",
      sec3: "",
      dummyDiv: "",
      scrolled: false,
      imageIndex: 0,
      scrollIndex: 0,
      selectedSlide: 0,
      canFetchAmountDetails: false,
      url: 'api1/v1/payments/donation/getAllSummary',
      target_dose: 0,
      showTicker: false
    };
  },

  computed: {
    payuUrl: function payuUrl() {
      return window.owConfig.payuURL;
    }
  },
  mounted: function mounted() {
    this.canFetchAmountDetails = true;
  },

  methods: {
    trackEvent: function trackEvent(name) {
      var url = 'https://apps.olacabs.com/web/event/publish?eventName=' + name + '&eventValue=';
      var obj = {
        "timestamp": new Date()
      };
      url = url + JSON.stringify(obj);
      new Image().src = url;
    },
    getErrorCB: function getErrorCB(e) {
      this.showTicker = false;
      console.log(e);
    },
    getSuccessCB: function getSuccessCB(e) {
      try {
        this.apiData = e.response;

        this.target_dose = Math.floor(e.response.target_dose).toLocaleString('en-IN');
        this.grandTotalDonation = (Math.floor(this.apiData.ola_donations) + Math.floor(this.apiData.total_number_of_doses)).toLocaleString('en-IN');
        var filledStatusWidth = (Math.floor(this.apiData.ola_donations) + Math.floor(this.apiData.total_number_of_doses)) * 100 / Math.floor(this.apiData.target_dose);
        filledStatusWidth = Math.floor(filledStatusWidth);
        console.log("filledStatusWidth=", filledStatusWidth);
        var elem = document.getElementById("outer-slider");
        elem.style.width = filledStatusWidth + "%";
        this.showTicker = true;
      } catch (ex) {
        console.log(ex);
      }
    }
  }

});